import Button from '@helsenorge/designsystem-react/components/Button';
import LazyIcon from '@helsenorge/designsystem-react/components/LazyIcon';

// Expose designsystem to Razor views
globalThis.HNDS = {
  Button,
  LazyIcon,
};
